import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WastePickup } from '../version.service';
import { todayLocalISO, fmtDate } from '../shared/format.utils';

@Component({
  selector: 'app-muell',
  templateUrl: './muell.component.html',
})
export class MuellComponent {
  @Input() nextPickupsByType: { type: string; name: string; date: string; icon: string }[] = [];
  @Input() wastePickups:      WastePickup[] = [];
  @Input() loading   = false;
  @Input() darkMode  = false;

  constructor(readonly translate: TranslateService) {}

  allDatesForType(type: string): string[] {
    const today = todayLocalISO();
    return this.wastePickups
      .filter(p => p.type === type && p.date >= today)
      .map(p => p.date)
      .slice(0, 5);
  }

  lastPickupForType(type: string): string | null {
    const today = todayLocalISO();
    const past = this.wastePickups
      .filter(p => p.type === type && p.date < today)
      .map(p => p.date);
    return past.length ? past[past.length - 1] : null;
  }

  lastPickupRelative(dateStr: string): string {
    const d = -this.daysUntil(dateStr);
    if (d === 0) return this.translate.instant('MUELL_HEUTE');
    if (d === 1) return this.translate.instant('MUELL_GESTERN');
    return this.translate.instant('MUELL_VOR_TAGEN', { n: d });
  }

  daysUntil(dateStr: string): number {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const target = new Date(dateStr + 'T00:00:00');
    return Math.round((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  }

  wasteRelative(dateStr: string): string {
    const d = this.daysUntil(dateStr);
    if (d === 0) return this.translate.instant('MUELL_HEUTE');
    if (d === 1) return this.translate.instant('MUELL_MORGEN');
    return this.translate.instant('MUELL_IN_TAGEN', { n: d });
  }

  fmtWasteDate(dateStr: string): string {
    return fmtDate(dateStr, this.translate.currentLang);
  }
}
